import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Redo16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M7.94886 2.79747C5.2058 2.79747 2.94444 5.13124 2.94444 8.02635C2.94444 10.9045 5.24048 13.2026 7.99999 13.2026C8.39886 13.2026 8.72221 13.5259 8.72221 13.9248C8.72221 14.3237 8.39886 14.647 7.99999 14.647C4.41929 14.647 1.5 11.6786 1.5 8.02635C1.5 4.39104 4.35171 1.35303 7.94886 1.35303C10.0038 1.35303 11.8594 2.33305 13.0556 3.91608V2.07525C13.0556 1.67638 13.3789 1.35303 13.7778 1.35303C14.1767 1.35303 14.5 1.67638 14.5 2.07525V6.02509C14.5 6.42396 14.1767 6.74731 13.7778 6.74731H13.3855C13.3742 6.74758 13.363 6.74757 13.3519 6.74731H9.94298C9.54411 6.74731 9.22076 6.42396 9.22076 6.02509C9.22076 5.62622 9.54411 5.30287 9.94298 5.30287H12.2472C11.3468 3.76011 9.7355 2.79747 7.94886 2.79747Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
